import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import {
  DiagnosticReport,
  RequestGroup,
  ServiceRequest,
} from "@curai/js-fhir-tools";

interface RelatedResourcesResponse {
  serviceRequest: ServiceRequest;
  diagnosticReports?: DiagnosticReport[];
  requestGroup?: RequestGroup;
}

export const useLabRelatedResources = ({
  patientId,
  serviceRequestId,
}: {
  patientId: string;
  serviceRequestId: string;
}) => {
  return useApi<RelatedResourcesResponse>({
    queryOptions: {
      enabled: Boolean(serviceRequestId),
      queryKey: QueryKeys.Patient.MedicalRecords.Labs.RELATED_RESOURCES(
        patientId,
        serviceRequestId,
      ),
      queryFn: async () => {
        const response = await axiosInstance.get(
          `/labs/order/test/${serviceRequestId}/related-resources`,
        );
        return response?.data;
      },
      select: (data) => {
        return {
          serviceRequest: new ServiceRequest(data.serviceRequest),
          diagnosticReports: data.diagnosticReports?.map(
            (report) => new DiagnosticReport(report),
          ),
          requestGroup: data.requestGroup
            ? new RequestGroup(data.requestGroup)
            : undefined,
        };
      },
    },
  });
};
